import React from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import { ACCESS_GATE } from '@lba-dev/package.local-globals/accessGate';

/*
  Écran de blocage affiché à la place de toute route réelle tant que l'accès
  à l'espace pro est bloqué (monté par Dashboard). Aucune page métier n'est
  rendue derrière : rien à révéler via les devtools. Contenu piloté par
  lib/local-globals/accessGate.js
*/
const AccessGate = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 1400,
        bgcolor: 'rgba(0, 0, 0, 0.55)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
      }}
    >
      <Paper
        elevation={8}
        sx={{ maxWidth: 420, width: '100%', p: 3, textAlign: 'center' }}
      >
        <Box
          component="img"
          src="/icon-192.png"
          alt="Les Bons Artisans"
          onError={(e) => {
            e.target.style.display = 'none';
          }}
          sx={{ width: 120, height: 120, borderRadius: 2, mb: 2 }}
        />
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          {ACCESS_GATE.title}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          {ACCESS_GATE.message}
        </Typography>
        <Button
          variant="contained"
          fullWidth
          onClick={() => navigate(ACCESS_GATE.resolvePath)}
          sx={{ fontWeight: 'bold' }}
        >
          Consulter et signer
        </Button>
      </Paper>
    </Box>
  );
};

export default AccessGate;
